import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGE_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MESUREMENT_ID
}

const firebaseKokoroKidsConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_KOKORO_KIDS_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_KOKORO_KIDS_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_KOKORO_KIDS_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_KOKORO_KIDS_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_KOKORO_KIDS_MESSAGE_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_KOKORO_KIDS_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_KOKORO_KIDS_MESUREMENT_ID
}

const firebaseApp = initializeApp(firebaseConfig, 'kokoro_schools')
const analytics = getAnalytics(firebaseApp)

const firebaseKokoroKidsApp = initializeApp(firebaseKokoroKidsConfig, 'kokoro_kids')
const authentication = getAuth(firebaseKokoroKidsApp)

export { analytics, authentication }
